var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({attrs:{"type":"text","placeholder":_vm.field.placeholder},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),{
    ..._vm.$listeners,
    input: (event) => _vm.$emit('input', event.target.value),
  }))
}
var staticRenderFns = []

export { render, staticRenderFns }